const TheCondolencePage = () =>
  import('@/views/condolence/TheCondolencePage.vue')

export const condolenceRootPages = [
  {
    path: '/condolence',
    name: 'condolence_page_route',
    redirect: {
      name: 'condolence_list'
    },
    children: [
      {
        path: '',
        name: 'condolence_list',
        component: TheCondolencePage
      }
    ]
  }
]
